import React, {useState, useEffect } from 'react';
// import useMediaQuery from '@mui/material/useMediaQuery';
// import { useTheme } from '@mui/material/styles';
import { useAuth } from '../../../hooks/useAuth';
import { getUser } from '../../../services/user-services';
import ProjectTabs from './answer-tabs';
import DialogUserInfo from './detail/dialog-user-info';
import SellStartNew from './sell-new';
import { getReqBuyDetail } from '../../../services/material-services';
import { Container } from '@mui/material';
import { useLocation } from 'react-router-dom';

export default function AnswerForm() {
    const { authData, authDataLang } = useAuth()
    const location = useLocation();
    const { state } = location;

    // const { onClose, selectedValue, open } = props
    // const [isAdmin, setIsAdmin] = useState(false)
    // const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)
    const [userClient, setUserClient] = useState(false)
    const [detailReqBuy, setDetailReqBuy] = React.useState(false)

    // const theme = useTheme()
    // const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

   
    // const handleClose = () => {
    //     onClose(state)
    // }

    useEffect(()=>{
        // if(authData?.user){
        //     setIsAdmin(authData.user?.profile?.is_permium)
        // }
        
        console.log("state", state)
        setLoading(true)
        const getData = async() =>{
            await getReqBuyDetail(authData?.token, state?.id)
            .then(data => {
                // console.log("getReqBuyDetail", data)
                setDetailReqBuy(data)

                setLoading(false)
            }).catch( e => {
                // setError(true)
                setLoading(false)
            })
        }
        if(state?.user?.id){
            getData()
        }
    }, [authData, state])

    useEffect(()=>{
        
        setLoading(true)
        const getData = async() =>{
            await getUser(authData?.token, state?.user?.id)
            .then(data => {
                
                setUserClient(data?.user)

                setLoading(false)
            }).catch( e => {
                // setError(true)
                setLoading(false)
            })
        }
        if(state?.user?.id){
            getData()
        }
    }, [authData, state])
    
    // const handleListItemClick = (value) => {
    //     onClose(value)
    // }

    return (
        <React.Fragment>

            <div dir={authDataLang?.view_sts ? "rtl" : "ltr"}>

                    <DialogUserInfo userClient={userClient} ReqUser={state}/>
                    <SellStartNew userClient={userClient} ReqUser={detailReqBuy}/>
            </div>
            <Container>

                    <div>
                        <ProjectTabs userClient={userClient} ReqUser={detailReqBuy}/>
                    </div>
            </Container>
            
        </React.Fragment>
    )
}

  